import React, { Component } from 'react';
import { connect } from 'react-redux';
import { showAlert } from '../actions';
import AlertMessage from '../components/AlertMessage';

class AlertMessageHolder extends Component {
  render() {
    const { msg, hideMessage } = this.props;

    if (msg) {
      return <AlertMessage message={msg} hideMessage={hideMessage} />;
    }
    return null;
  }
}

const mapStateToProps = (state) => {
  return {
    msg: state.datasource.alertMessage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    hideMessage: (e) => {
      if (e) {
        e.preventDefault();
      }
      dispatch(showAlert(null));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AlertMessageHolder);
